export function isCategoryMatch(query: string, category: string) {
  return category.toLowerCase().replace(/_/g, ' ').includes(query);
}
